export default __webpack_public_path__ + "static/media/white-plus-icon.f160af8b.svg";